<template>
  <common-card class="mt-3">
    <v-row class="px-4 py-4 align-center">
      <v-col cols="12" md="6">
        <h1>Visualización de Producto</h1>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-end align-center">
        <v-btn class="common-botton" dark @click="$router.go(-1)" style="min-width: 140px;">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-row v-if="loading" class="justify-center px-4 py-8">
      <v-col cols="12" class="text-center py-10">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
      </v-col>
    </v-row>

    <v-row v-else class="px-4 py-4">
      <v-col cols="12">
        <v-card class="mb-6" elevation="1">
          <v-card-title class="text-h6 font-weight-bold">Datos generales</v-card-title>
          <v-card-text class="pt-0 pb-6">
            <v-row class="px-4 py-4">
              <v-col
                cols="12"
                md="4"
                v-for="([key, value]) in displayedRequiredFields"
                :key="key"
              >
                <v-text-field
                  :label="formatLabel(key)"
                  :value="getDisplayValue(key, value)"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card elevation="1">
          <v-card-title class="text-h6 font-weight-bold">Configuraciones extra</v-card-title>
          <v-card-text class="pt-0 pb-6">
            <v-row class="px-4 py-4">
              <v-col
                cols="12"
                md="4"
                v-for="([key, value]) in displayedExtraFields"
                :key="key"
              >
                <v-text-field
                  :label="formatLabel(key)"
                  :value="getDisplayValue(key, value)"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </common-card>
</template>

<script>
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import { getProductoDetalleByID } from "@/services/productos/product.service";

export default {
  name: "DetalleProductoAlianza",
  components: {
    CommonCard,
  },
  data() {
    return {
      loading: true,
      producto: {},
    };
  },
  computed: {
    displayedRequiredFields() {
      return this.getFieldEntries([
        "ramoNombre",
        "canalNombre",
        "nombre",
        "nombreAseguradora",
        "status",
        "alianzaNombre",
        "vigencia",
        "beneficiario",
        "cuotas",
        "certificado",
      ]);
    },
    displayedExtraFields() {
      return this.getFieldEntries([
        "comision_agente",
        "comision_segurify",
        "comision_aseguradora",
        "comision_total",
        "bono",
        "tecnologia",
        "agenteNombre",
        "prima_neta",
        "total",
        "primer_pago",
        "subsecuente_pago",
        "suma_asegurada",
        "fecha_creacion",
        "fecha_modificacion",
        "nombre_modificador",
        "limite_familiares",
        "limite_beneficiarios",
        "limite_hijos",
        "dias_periodo_gracia",
        "inbound",
      ]);
    },
  },
  methods: {
    getFieldEntries(keys) {
      return keys
        .filter((key) => Object.prototype.hasOwnProperty.call(this.producto, key))
        .map((key) => [key, this.producto[key]]);
    },
    getCatalogLabel(key, value) {
      if (key === "status") {
        return this.getStatusLabel(value);
      }

      if (key === "alianza_intermx_id") {
        return this.producto.alianzaNombre || this.producto.alianza_nombre || value || "Sin llenar";
      }

      if (["aseguradoraId", "aseguradora_id", "aseguradora"].includes(key)) {
        return this.producto.nombreAseguradora || this.producto.nombre_aseguradora || value || "Sin llenar";
      }

      if (key === "nombreAseguradora") {
        return this.producto.nombreAseguradora || this.producto.nombre_aseguradora || value || "Sin llenar";
      }

      if (["ramoId", "ramo_id"].includes(key)) {
        return this.producto.ramoNombre || this.producto.ramo || value || "Sin llenar";
      }

      if (key === "canal") {
        return this.producto.canalNombre || this.producto.canal_nombre || value || "Sin llenar";
      }

      if (key === "agente_id" || key === "agenteId") {
        return (
          this.producto.agenteNombre ||
          this.producto.agente_nombre ||
          [this.producto.agenteNombre, this.producto.agenteApellidoPaterno, this.producto.agenteApellidoMaterno]
            .filter(Boolean)
            .join(" ") ||
          value ||
          "Sin llenar"
        );
      }

      return value;
    },
    getStatusLabel(value) {
      if (value === 2 || value === "Inactivo" || value === "INACTIVO") {
        return "Inactivo";
      }

      if (value === 1 || value === "Activo" || value === "ACTIVO") {
        return "Activo";
      }

      return value || "Sin llenar";
    },
    normalizeValue(value) {
      if (value === null || value === undefined || value === "") {
        return "Sin llenar";
      }
      if (typeof value === "boolean") {
        return value ? "Sí" : "No";
      }
      return value;
    },
    getDisplayValue(key, value) {
      const booleanFields = [
        "beneficiario",
        "cuotas",
        "certificado",
        "tecnologia",
        "inbound",
      ];

      if (booleanFields.includes(key)) {
        if (value === 1 || value === true) return "Sí";
        if (value === 0 || value === false) return "No";
        return "Sin llenar";
      }
      
      const dateFields = [
        "fecha_creacion",
        "fecha_modificacion",
      ];

      if (dateFields.includes(key)) {
        if (value === null || value === undefined || value === "") {
          return "Sin llenar";
        }

        return new Date(value).toLocaleString("es-MX");
      }
      
      
      const mappedValue = this.getCatalogLabel(key, value);
      return this.normalizeValue(mappedValue);
    },
    async fetchProducto() {
      this.loading = true;
      try {
        const producto = await getProductoDetalleByID(this.$route.params.id);
        this.producto = producto || {};

        if (
          !this.producto ||
          this.producto.alianza_intermx_id === null ||
          this.producto.alianza_intermx_id === undefined ||
          this.producto.alianza_intermx_id === ""
        ){
          this.$toast.error(
            "El producto seleccionado no pertenece a una alianza",
            {
              position: "top-right",
              timeout: 3000,
            }
          );

          this.$router.go(-1);
        }
      }catch (error) {
        console.error("Error al cargar producto:", error);

        this.producto = {};

        if (error.response?.status === 404) {
          this.$toast.error(
            "El producto seleccionado no pertenece a una alianza",
            {
              position: "top-right",
              timeout: 3000,
            }
          );
        } else {
          this.$toast.error(
            "No se pudo cargar el producto",
            {
              position: "top-right",
              timeout: 3000,
            }
          );
        }

        this.$router.go(-1);

      }finally {
        this.loading = false;
      }
    },
    formatLabel(key) {
      const labels = {
        alianza_intermx_id: "Alianza Inter.mx",
        nombreAseguradora: "Aseguradora",
        agenteNombre: "Agente",
        comision_agente: "% Comisión agente",
        comision_segurify: "% Comisión Segurify",
        comision_aseguradora: "% Comisión pagada por la aseguradora",
        comision_total: "% Comisión total",
        bono: "% Bono",
        prima_neta: "Prima neta",
        primer_pago: "Primer pago",
        subsecuente_pago: "Pago subsecuente",
        suma_asegurada: "Suma asegurada",
        fecha_creacion: "Fecha creación",
        fecha_modificacion: "Fecha modificación",
        nombre_modificador: "Nombre modificador",
        limite_familiares: "Límite familiares",
        limite_beneficiarios: "Límite beneficiarios",
        limite_hijos: "Límite hijos",
        dias_periodo_gracia: "Días periodo de gracia",
        tecnologia: "Tecnología",
        inbound: "Inbound",
        ramoNombre: "Ramo",
        canalNombre: "Canal",
        alianzaNombre: "Alianza Inter.mx",
      };

      if (labels[key]) {
        return labels[key];
      }

      return key
        .replace(/([A-Z])/g, " $1")
        .replace(/_/g, " ")
        .replace(/^./, (c) => c.toUpperCase());
    },
  },
  mounted() {
    this.fetchProducto();
  },
};
</script>
